import { Button } from '@treezor/design-system';

import { useProfileContext } from '@/features/context/ProfileContext';
import { useAccesControl } from '@/hooks/useAccessControl';
import { useAppDispatch } from '@/hooks/redux-helpers';

import { openModal } from '@/store/actions/core.actions';

import { featuresSlugs } from '@/features/roles/store/models/features.model';

import { IDownloadOperationsModalProps } from './DownloadOperationsModal';

interface IDownloadOperationsProps {
  currentWalletId: number;
}

export const DownloadOperations = ({ currentWalletId }: IDownloadOperationsProps) => {
  const { user, metadata } = useProfileContext();
  const dispatch = useAppDispatch();
  const { hasAccessToFeature } = useAccesControl();

  const toggleOperationModal = () =>
    dispatch(
      openModal<IDownloadOperationsModalProps>(
        'downloadOperationsModal',
        { user, currentWalletId, walletColumns: metadata.walletColumns },
        { maxWidth: 'md' },
      ),
    );

  if (!hasAccessToFeature(featuresSlugs.DOWNLOAD_OPERATIONS)) {
    return null;
  }

  return (
    <>
      {metadata.walletColumns && (
        <Button
          size="s"
          variant="tertiary"
          id="download-operations-dialog-btn"
          onClick={toggleOperationModal}
          icon="download"
          testId="wallet-download-operations"
        ></Button>
      )}
    </>
  );
};
